export function PublicSiteShell({
  aboutPageMode,
  branding,
  chapterOrganization,
  children,
  currentMember,
  currentMemberPlan,
  currentSignupIntent,
  currentSignupPlan,
  displayName,
  heroDescription,
  heroKicker,
  isAuthenticated,
  libertyFacilityLine,
  libertyPublic,
  memberAccountDetail,
  memberAccountLabel,
  memberConsoleIconUrl,
  memberConsoleMode,
  memberLabel,
  memberPortalBlocked,
  memberPortalHref,
  memberPortalNeedsSignIn,
  memberStatusLabel,
  membershipPageMode,
  onMemberSignOut,
  onRequireAuth,
  publicAboutHref,
  publicCompletionMode,
  publicHeroImageUrl,
  publicHeroStyle,
  publicHomeHref,
  publicLogoUrl,
  publicStatusTitle,
  rangeFacts,
  safetyAccent,
  showMemberPortalContent,
  slug,
  workspaceLabel
}) {
  return (
    <main
      className={`public-range-shell ${memberConsoleMode ? "member-console-shell" : ""} ${libertyPublic ? "is-liberty-public-site" : ""} ${chapterOrganization ? "is-chapter-organization-site" : ""} ${membershipPageMode ? "is-membership-page" : ""} ${aboutPageMode ? "is-about-page" : ""} ${publicCompletionMode ? "is-checkout-completion" : ""}`}
      style={{
        "--public-primary": libertyPublic ? "#17211b" : (branding.primaryColor || "#2e4d3b"),
        "--public-accent": branding.accentColor || safetyAccent || "#1f6f68",
        "--public-safety": safetyAccent || branding.accentColor || "#b7791f"
      }}
    >
      {memberConsoleMode && (
        <div className="member-console-topbar">
          <a href={`/r/${encodeURIComponent(slug)}`} className="member-console-range-link">
            <span className="public-range-mark member-console-topbar-mark">
              {memberConsoleIconUrl ? <img src={memberConsoleIconUrl} alt="" /> : (branding.shortName || "RG")}
            </span>
            <span>
              <strong>{displayName}</strong>
              <small>Member console</small>
            </span>
          </a>
          <div className="member-console-account">
            <span>
              <strong>{memberAccountLabel}</strong>
              {memberAccountDetail && <small>{memberAccountDetail}</small>}
            </span>
            {onMemberSignOut && (
              <button type="button" className="secondary-button" onClick={onMemberSignOut}>
                Sign out
              </button>
            )}
          </div>
        </div>
      )}

      {memberConsoleMode && !showMemberPortalContent ? (
        <section className="member-console-status-hero">
          <div className="member-console-status-copy">
            <span className="public-section-kicker">Member status</span>
            <h1>{displayName}</h1>
            <p>
              {memberPortalNeedsSignIn
                ? `Sign in to view your ${memberLabel} record for this ${workspaceLabel}.`
                : memberPortalBlocked
                  ? `This ArmorySync account is not connected to a membership for this ${workspaceLabel} yet.`
                  : currentMember
                    ? `Membership record: ${memberStatusLabel(currentMember.status)}`
                    : currentSignupIntent
                      ? "Membership signup is in progress."
                      : "Checking membership access for this range."}
            </p>
          </div>
          <div className="member-console-status-meta">
            <div>
              <span>Signed in as</span>
              <strong>{memberAccountLabel}</strong>
              {memberAccountDetail && <small>{memberAccountDetail}</small>}
            </div>
            <div>
              <span>Membership plan</span>
              <strong>{currentMemberPlan?.name || currentSignupPlan?.name || (currentMember ? "Member plan on file" : "No membership selected")}</strong>
            </div>
          </div>
        </section>
      ) : !memberConsoleMode ? (
        <section
          className={`public-range-hero ${publicHeroImageUrl ? "has-hero-image" : ""}`}
          style={publicHeroStyle}
        >
          {!libertyPublic && (
            <div className="public-site-account-action">
              {isAuthenticated ? (
                <a href={memberPortalHref}>Member portal</a>
              ) : (
                <button
                  type="button"
                  onClick={() => onRequireAuth({ memberIntent: "membership", hash: "#member-dashboard" })}
                >
                  Sign in or create account
                </button>
              )}
            </div>
          )}
          <div className="public-range-hero-content">
            <span className="public-range-mark">
              {publicLogoUrl ? (
                <img src={publicLogoUrl} alt="" />
              ) : (
                branding.shortName || "RG"
              )}
            </span>
            <p className="eyebrow">{heroKicker}</p>
            <h1>{publicCompletionMode ? (publicStatusTitle || "Payment received") : displayName}</h1>
            {heroDescription && <p>{heroDescription}</p>}
            {libertyPublic && !publicCompletionMode && <p className="public-liberty-facility-line">{libertyFacilityLine}</p>}
            {!publicCompletionMode && (
              <div className="public-hero-actions">
                {membershipPageMode ? (
                  <>
                    <a href={publicHomeHref}>Main {workspaceLabel} page</a>
                    {publicAboutHref && <a href={publicAboutHref}>About us</a>}
                  </>
                ) : aboutPageMode ? (
                  <>
                    <a href={publicHomeHref}>Main {workspaceLabel} page</a>
                    <a href={publicHomeHref.includes("/r/") ? `${publicHomeHref}/membership` : "/membership"}>Membership information</a>
                  </>
                ) : (
                  <>
                    {publicAboutHref && <a href={publicAboutHref}>About us</a>}
                    <a href="#updates">Membership information</a>
                  </>
                )}
              </div>
            )}
            {!membershipPageMode && !publicCompletionMode && (
              <div className="public-range-facts">
                {rangeFacts.map((fact) => (
                  <div key={fact.label}>
                    <span>{fact.label}</span>
                    <strong>{fact.value}</strong>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      ) : null}

      <section className="public-range-content">
        {children}
      </section>
    </main>
  );
}
